import React from 'react';
import { DialogProvider } from './src/contexts/DialogContext';

require('prismjs/plugins/command-line/prism-command-line.css');
require('prismjs/plugins/line-numbers/prism-line-numbers.css');

export const wrapRootElement = ({ element }) => (
  <DialogProvider>{element}</DialogProvider>
);

export const onRouteUpdate = () => {
  // Dispatch a custom event that your hook can listen to
  window.dispatchEvent(new Event('routeChanged'));
};
